import { FundGetData } from '~/api/def/endpoints/fundEndpoint';
import { Fund, Hierarchy } from '~/types';

export const fundsToHierarchy = (
  funds: FundGetData[],
): { hierarchy: Hierarchy[]; fundSet: Set<string> } => {
  const hierarchy: Hierarchy[] = [];
  const fundSet = new Set<string>();
  funds.forEach((fund) => {
    fundSet.add(fund.id);
    const existing = hierarchy.find(
      (e) => e.legalJurisdiction.name === fund.jurisdiction.name,
    );
    const fundAdd: Fund = {
      fundId: fund.id,
      name: fund.name,
      size: fund.size,
      currency: fund.currency,
      inceptionDate: new Date(fund.inceptionDate),
      terminationDate: new Date(fund.terminationDate),
      jurisdiction: fund.jurisdiction.abbreviation,
      pcGDriveFolderSync: fund.pcGDriveFolderSync,
    };
    if (existing) {
      existing.funds.push(fundAdd);
    } else {
      hierarchy.push({
        legalJurisdiction: {
          jurisdiction: fund.jurisdiction.abbreviation,
          name: fund.jurisdiction.name,
          id: fund.jurisdiction.id,
        },
        funds: [fundAdd],
      });
    }
  });
  return { hierarchy, fundSet };
};

/**  get fund from fund
 * */
export const getFundByIdFromHierarchy = (
  fundId: string,
  [...hierarchy]: Hierarchy[],
): Fund | null => {
  let foundFund: Fund | null = null;
  hierarchy.forEach((jurisdiction: Hierarchy) => {
    const foundInHierarchy = jurisdiction.funds.find(
      (f) => f.fundId === fundId,
    );
    if (foundInHierarchy) {
      foundFund = { ...foundInHierarchy };
    }
    return;
  });
  return foundFund;
};
